import request from '@/utils/request'

let TopicApi = {
  /*题目列表*/
  topiclist(data, errorback) {
    return request._post('/shop/topic.topic/index', data, errorback);
  },
  /*所有题目列表*/
  topicalllist(data, errorback) {
    return request._post('/shop/topic.topic/indexs', data, errorback);
  },
  /*添加题目*/
  toAddtopic(data, errorback) {
    return request._get('/shop/topic.topic/add', data, errorback);
  },
  /*添加题目*/
  addtopic(data, errorback) {
    return request._post('/shop/topic.topic/add', data, errorback);
  },
  /*题目详情*/
  toEdittopic(data, errorback) {
    return request._get('/shop/topic.topic/edit', data, errorback);
  },
  /*编辑题目*/
  edittopic(data, errorback) {
    return request._post('/shop/topic.topic/edit', data, errorback);
  },
  /*删除题目*/
  deletetopic(data, errorback) {
    return request._post('/shop/topic.topic/delete', data, errorback);
  },
  /*批量导入*/
  batchDelivery(data, errorback) {
      return request._get('/shop/topic.delivery/csv', data, errorback);
  },
  /*用户答题记录列表*/
  recordlist(data, errorback) {
    return request._post('/shop/topic.record/index', data, errorback);
  },
  getAnswerDetail(data, errorback) {
    return request._post('/shop/topic.record/detail', data, errorback);
  },
  /*设置任务*/
  settingTopic(data, errorback) {
    return request._post('/shop/topic.topic/setting', data, errorback);
  },
  /*设置任务*/
  toSettingTopic(data, errorback) {
    return request._get('/shop/topic.topic/setting', data, errorback);
  },
}
export default TopicApi;



// WEBPACK FOOTER //
// ./src/api/topic.js